import React from 'react';

const Tools = () => {
  return (
    <iframe
      src="https://v2-embednotion.com/Tools-98730a3c688c4c4b86b235ee84ce981e"
      title="Tools"
      style={{
        width: '100%',
        height: '600px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        padding: 'none',
        boxShadow: '0 2px 2px #ccc '
      }}
    />
  );
};

export default Tools;
